module.exports = __webpack_public_path__ + "static/microscope-0a163f4712bf5ee8cd24f78d2a514f6e.png";